<template>
    <div id="navigation" class="flex-center">
        <Control
            id="control-left"
            direction="Left"
            :show="navigation.showLeftControl"
            @navigate="$emit('navigate', $event)"
        />
        <Control
            id="control-right"
            direction="Right"
            :show="navigation.showRightControl"
            @navigate="$emit('navigate', $event)"
        />
    </div>
</template>

<script>
import Control from "@/components/Timeline/Navigation/Overlay/Control.vue";

export default {
    name: "TimelineOverlayNavigation",
    props: { navigation: Object },
    components: { Control },
    emits: [ "navigate" ]
};
</script>